module.exports = __webpack_public_path__ + "img/1537840422.8f72ee26.jpg";